import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import { CardProps } from '@/interfaces/raDashboard.interface'
import { cardStyle, cardSubtitleStyle, cardTitleStyle } from '@/styles/reportDashboardStyles'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'

const EmptyCard: React.FC<CardProps> = (props) => {
  const theme = useTheme();

  const isVisible = false;
  const [cardText, setCardText] = React.useState(props.w + 'x' + props.h);

  const cardLayout = {
    opacity: isVisible ? 1 : 0,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div style={{ ...cardStyle, ...cardLayout, backgroundColor: theme.cardBackground, border: `1px solid ${theme.border}`}}>
      <Stack>
        <Typography style={{...cardTitleStyle, color: theme.textPrimary}}>Empty</Typography>
        <Typography style={{...cardSubtitleStyle, color: theme.textSecondary}}>
          {cardText}
        </Typography>
      </Stack>
    </div>
  );
};

export default EmptyCard;
